module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"g":"Année de début","h":"Année de fin","i":"Institut","j":"Description"},"en":{"g":"Start year","h":"End year","i":"Institute","j":"Description"}}')
  delete Component.options._Ctor
}
